export class ApiError extends Error {
    status;
    body;
    constructor(status, body) {
        super(body?.message || `API ${status}`);
        this.status = status;
        this.body = body;
        this.name = "ApiError";
    }
    /** Машиночитаемый код ошибки (= `body.error` канонического формата). */
    get code() {
        return typeof this.body?.error === "string" ? this.body.error : undefined;
    }
    /** Поле, к которому относится ошибка валидации (= `body.field`). */
    get field() {
        return typeof this.body?.field === "string" ? this.body.field : undefined;
    }
    /** Структурные детали ошибки (= `body.details`), форма зависит от кода. */
    get details() {
        return this.body?.details;
    }
}
export function createApi(opts = {}) {
    const baseUrl = opts.baseUrl ?? "";
    return async function api(path, init = {}) {
        const headers = {
            ...(opts.getAuthHeaders ? opts.getAuthHeaders() : {}),
            ...init.headers,
        };
        // Не выставляем content-type для GET / DELETE без тела — Fastify
        // отвергает пустой body с json-заголовком.
        if (init.body != null && !(init.body instanceof FormData)) {
            headers["content-type"] = headers["content-type"] ?? "application/json";
        }
        const fetchInit = {
            ...init,
            headers,
        };
        if (opts.credentials)
            fetchInit.credentials = opts.credentials;
        const res = await fetch(`${baseUrl}${path}`, fetchInit);
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new ApiError(res.status, body);
        }
        if (res.status === 204)
            return undefined;
        return res.json();
    };
}
//# sourceMappingURL=index.js.map